import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddBeneficiaryStep } from '@pg-app/client/manage-recipient/constants/add-beneficiary-constant';
import { AddRecipientFrom } from '@pg-app/client/manage-recipient/constants/add-recipient-constants';
import { NewRecipientModel } from '@pg-app/client/manage-recipient/models/recipient.model';
import { Regex } from '@pg-app/shared/constants/regex';

@Component({
  selector: 'np-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {
  @Input() action = AddRecipientFrom.ManageRecipient;
  addRecipientFrom = AddRecipientFrom;

  remitterDetails: FormGroup;
  constructor(
    private fb: FormBuilder,
    public newRecipientModel: NewRecipientModel
  ) { }

  ngOnInit(): void {
    this.remitterDetails = this.fb.group({
      ultimateRemitterSelected: [null],

      remitterType: [null],
      remitterCompanyName: [null],
      remitterFirstName: [null],
      remitterLastName: [null],
      remitterAddress: [null],
      remitterCity: [null],
      remitterPostCode: [null],
      remitterState: [null],
      remitterCountry: [null],
      remitterCompanyNumber: [null],
      remitterDOB: [null]
    });
  }

  next() {
    this.remitterDetails.markAllAsTouched();
    if (this.remitterDetails.valid) {
      const remitterCountry = this.newRecipientModel.step1.countries.find(p => p.name === this.remitterDetails.get('remitterCountry').value);

      this.newRecipientModel.existingUltimateRemitterIdSelected = this.remitterDetails.get('ultimateRemitterSelected').value;

      if (this.newRecipientModel.existingUltimateRemitterIdSelected) {
        this.newRecipientModel.remitterDetail = null;
      } else {
        this.newRecipientModel.remitterDetail = {
          ultimateRemitterType: this.remitterDetails.get('remitterType').value,
          ultimateRemitterCompanyName: this.remitterDetails.get('remitterCompanyName').value,
          ultimateRemitterFirstName: this.remitterDetails.get('remitterFirstName').value,
          ultimateRemitterLastName: this.remitterDetails.get('remitterLastName').value,
          ultimateRemitterAddress: this.remitterDetails.get('remitterAddress').value,
          ultimateRemitterCity: this.remitterDetails.get('remitterCity').value,
          ultimateRemitterPostCode: this.remitterDetails.get('remitterPostCode').value,
          ultimateRemitterState: this.remitterDetails.get('remitterState').value,
          ultimateRemitterCountryId: remitterCountry ? remitterCountry.id : null,
          ultimateRemitterCompanyNumber: this.remitterDetails.get('remitterCompanyNumber').value,
          ultimateRemitterDOB: this.remitterDetails.get('remitterDOB').value,
        };
      }

      this.newRecipientModel.currentStep = AddBeneficiaryStep.Authy;
    }
  }

  back() {
    this.newRecipientModel.currentStep = AddBeneficiaryStep.STEP2;
  }
}
